(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-currency"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ps-money-converter')) {
    customElements.define('ps-money-converter', class extends HTMLElement {
      static cacheKey = 'ps-display-rates-myr-v1';
      static currencies = ['USD', 'CAD', 'CNY', 'AED', 'SAR', 'AUD', 'EUR', 'MXN', 'KRW', 'TWD', 'SGD'];
      static priceSelector = 'span.money, .price-item, .unit-price dd';

      connectedCallback() {
        this.prices = new WeakMap();
        this.active = true;
        this.currency = 'MYR';
        this.rate = 1;
        this.select = this.querySelector('select');
        this.status = this.querySelector('.ps-money-status');
        this.desired = this.select.selectedOptions[0]?.dataset.currency || 'MYR';
        this.onChange = () => this.querySelector('form').requestSubmit();
        this.select.addEventListener('change', this.onChange);
        this.options = Array.from(this.select.options);
        this.options.forEach(option => {
          option.textContent = `${option.dataset.countryName} (${option.dataset.currency})`;
        });
        this.select.selectedOptions[0].textContent = `${this.select.selectedOptions[0].dataset.countryName} (MYR)`;
        this.observer = new MutationObserver(() => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.renderPrices();
          });
        });
        this.observer.observe(document.body, { subtree: true, childList: true, characterData: true });
        this.loadRates();
      }

      validRows(rows) {
        if (!Array.isArray(rows)) return {};
        const now = Date.now();
        const rates = {};
        rows.forEach(row => {
          if (!row || row.base !== 'MYR' || !this.constructor.currencies.includes(row.quote)) return;
          if (!/^\d{4}-\d{2}-\d{2}$/.test(row.date || '')) return;
          const age = now - Date.parse(`${row.date}T00:00:00Z`);
          if (!Number.isFinite(age) || age < -86400000 || age > 7 * 86400000) return;
          if (typeof row.rate !== 'number' || !Number.isFinite(row.rate) || row.rate <= 0) return;
          rates[row.quote] = row;
        });
        return rates;
      }

      async loadRates() {
        if (this.desired === 'MYR') {
          this.setDisplay(null);
          return;
        }
        this.showStatus(this.dataset.loading);
        let cached;
        try { cached = JSON.parse(localStorage.getItem(this.constructor.cacheKey)); } catch {}
        const cachedRate = this.validRows(cached?.rows)[this.desired];
        if (cachedRate) this.setDisplay(cachedRate);
        const fetchedAge = Date.now() - Number(cached?.fetchedAt);
        if (cachedRate && fetchedAge >= 0 && fetchedAge < 12 * 3600000) return;
        this.abort = new AbortController();
        const timeout = setTimeout(() => this.abort.abort(), 6500);
        try {
          const url = `https://api.frankfurter.dev/v2/rates?base=MYR&quotes=${this.constructor.currencies.join(',')}`;
          const response = await fetch(url, { signal: this.abort.signal, credentials: 'omit', referrerPolicy: 'no-referrer' });
          if (!response.ok) throw new Error('Rates unavailable');
          const rows = await response.json();
          const valid = this.validRows(rows);
          if (!valid[this.desired]) throw new Error('Missing or stale rate');
          if (!this.active) return;
          try { localStorage.setItem(this.constructor.cacheKey, JSON.stringify({ rows: Object.values(valid), fetchedAt: Date.now() })); } catch {}
          this.setDisplay(valid[this.desired]);
        } catch {
          if (this.active && !cachedRate) this.setDisplay(null);
        } finally {
          clearTimeout(timeout);
        }
      }

      showStatus(text) {
        this.status.hidden = !text;
        if (this.status.textContent !== text) this.status.textContent = text;
      }

      setDisplay(row) {
        this.currency = row ? this.desired : 'MYR';
        this.rate = row?.rate || 1;
        const currencyLabel = this.querySelector('[data-ps-currency]');
        if (currencyLabel && currencyLabel.textContent !== this.currency) currencyLabel.textContent = this.currency;
        this.formatter = new Intl.NumberFormat('en-MY', { style: 'currency', currency: this.currency, currencyDisplay: 'symbol' });
        const option = this.select.selectedOptions[0];
        const label = `${option.dataset.countryName} (${this.currency})`;
        if (option.textContent !== label) option.textContent = label;
        const message = row ? `${this.currency}: ${this.dataset.notice}` : this.desired === 'MYR' ? '' : this.dataset.fallback;
        this.showStatus(message);
        this.renderPrices();
      }

      formatPrice(value) {
        const compactSymbol = { MYR: 'RM', SGD: 'S$' }[this.currency];
        return this.formatter.formatToParts(value).map(part => {
          if (compactSymbol && part.type === 'currency') return compactSymbol;
          if (compactSymbol && part.type === 'literal' && /^\s+$/.test(part.value)) return '';
          return part.value;
        }).join('');
      }

      formatMyr(minor) {
        const negative = minor < 0;
        const abs = Math.abs(minor);
        const amount = `${Math.floor(abs / 100).toLocaleString('en-MY')}.${String(abs % 100).padStart(2, '0')}`;
        return `${negative ? '-' : ''}RM${amount}`;
      }

      parsePrice(text) {
        const clean = text.trim().replace(/<span class=["']money["']>/g, '').replace(/<\/span>/g, '');
        const match = clean.match(/^(-?)RM\s*(-?)(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{2}))?(?:\s*MYR){0,2}(\s*\/\s*[\w²³.]+)?$/);
        if (!match || (match[1] && match[2])) return null;
        const minor = (Number(match[3].replaceAll(',', '')) * 100 + Number(match[4] || 0)) * (match[1] || match[2] ? -1 : 1);
        return Number.isSafeInteger(minor) ? { minor, suffix: match[5] || '' } : null;
      }

      renderPrices() {
        if (!this.formatter) return;
        document.querySelectorAll(this.constructor.priceSelector).forEach(element => {
          if (element.children.length) return;
          const text = element.textContent;
          const saved = this.prices.get(element);
          const source = saved && saved.output === text ? saved.original : text;
          const parsed = this.parsePrice(source);
          if (!parsed) return;
          const value = parsed.minor / 100 * this.rate;
          if (!Number.isFinite(value)) return;
          const formatted = this.formatPrice(value);
          const onProductPrice = element.closest('.product__price, [id^="price-sticky-"]');
          const localPrice = /^[A-Za-z]/.test(formatted) ? formatted : `${this.currency} ${formatted}`;
          const myrLabel = this.formatMyr(parsed.minor);
          const output = onProductPrice && this.currency !== 'MYR'
            ? `${localPrice} / ${myrLabel}${parsed.suffix}`
            : formatted + parsed.suffix;
          this.prices.set(element, { original: source, output });
          if (text === output) return;
          if (onProductPrice && this.currency !== 'MYR') {
            element.textContent = localPrice;
            const myr = document.createElement('span');
            myr.className = 'product__price-myr';
            myr.textContent = ` / ${myrLabel}${parsed.suffix}`;
            element.append(myr);
            return;
          }
          element.textContent = output;
        });
        document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(button => {
          const parent = button.parentElement;
          let notice = parent.querySelector('[data-ps-checkout-notice]');
          if (this.currency === 'MYR') {
            notice?.remove();
            return;
          }
          if (!notice) {
            notice = document.createElement('p');
            notice.setAttribute('data-ps-checkout-notice', '');
            button.before(notice);
          }
          if (notice.textContent !== this.dataset.checkout) notice.textContent = this.dataset.checkout;
        });
        this.renderProductChargeNote();
      }

      renderProductChargeNote() {
        document.querySelectorAll('.product__price').forEach(block => {
          let note = block.querySelector('[data-ps-product-charge]');
          if (this.currency === 'MYR') {
            note?.remove();
            return;
          }
          if (!note) {
            note = document.createElement('p');
            note.setAttribute('data-ps-product-charge', '');
            note.className = 'product__price-charge';
            const inner = block.querySelector('.product__price-inner');
            if (inner) inner.after(note);
            else block.append(note);
          }
          if (note.textContent !== this.dataset.productCharge) note.textContent = this.dataset.productCharge;
        });
      }

      disconnectedCallback() {
        this.active = false;
        this.abort?.abort();
        this.select?.removeEventListener('change', this.onChange);
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        document.querySelectorAll(this.constructor.priceSelector).forEach(element => {
          const saved = this.prices?.get(element);
          if (saved && element.textContent === saved.output) element.textContent = saved.original;
        });
        document.querySelectorAll('[data-ps-checkout-notice], [data-ps-product-charge]').forEach(notice => notice.remove());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
